import React, { useEffect } from "react";
import { ManageStockBasePage } from "../..";
import { useRenaveContext } from "../../../../hooks";
import { RenaveMenuStepsEnum } from "../../../../models";
import { VehicleAptnessOrganism } from "../../../organisms";

export const AptnessQueryPage: React.FC = () => {
  const { setMenuSelectedStepContext } = useRenaveContext();

  useEffect(() => {
    setMenuSelectedStepContext(RenaveMenuStepsEnum.Aptness);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ManageStockBasePage>
      <VehicleAptnessOrganism />
    </ManageStockBasePage>
  );
};
